import { GRETA_AI_CHAT_SUGGESTED_PROMPTS } from '../../GretaAIChat.constants'
import { useGretaAIChatContext } from '../../GretaAIChat.hooks'
import { getGretaAIChatVisibleSuggestedPrompts } from '../../GretaAIChat.utils'
import { GretaAIChatLockedState } from '../../GretaAIChatLockedState'
import { GretaAIChatMessageList } from '../../GretaAIChatMessageList'

function GretaAIChatPanelFeed({ inputRef }) {
  const { actions, conversation, panel } = useGretaAIChatContext()

  const { activeChatId, isLimitReached, isLocked } = panel

  const {
    displayName,
    feedbackByMessageId,
    messages,
    pendingAnswerFileName,
    status,
    turnStartedAt,
    onLoadOlderMessages,
    onReloadMessages,
  } = conversation

  const { setDraft, onRetry, onSendMessage, onSubmitFeedback } = actions

  function handleSelectPrompt(text) {
    setDraft(text)
    inputRef.current?.focus()
  }

  return isLocked ? (
    <GretaAIChatLockedState />
  ) : (
    <GretaAIChatMessageList
      displayName={displayName}
      feedbackByMessageId={feedbackByMessageId}
      isLimitReached={isLimitReached}
      isNewChat={activeChatId === null}
      messages={messages}
      pendingAnswerFileName={pendingAnswerFileName}
      status={status}
      suggestedPrompts={getGretaAIChatVisibleSuggestedPrompts(
        GRETA_AI_CHAT_SUGGESTED_PROMPTS
      )}
      turnStartedAt={turnStartedAt}
      onLoadOlderMessages={onLoadOlderMessages}
      onReloadMessages={onReloadMessages}
      onRetry={onRetry}
      onSelectPrompt={handleSelectPrompt}
      onSendPrompt={onSendMessage}
      onSubmitFeedback={onSubmitFeedback}
    />
  )
}

export default GretaAIChatPanelFeed
